export default __webpack_public_path__ + "assets/SpaceIndustrialBase.eed2a2c9.png";